import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Priya & Raj S.",
    location: "Brampton, ON",
    rating: 5,
    text:
      "They turned our unfinished basement into a fully legal 2-bedroom rental in 10 weeks. Permits, inspections — all handled. Tenants in within a month.",
    project: "Legal Basement",
  },
  {
    name: "Michael T.",
    location: "Mississauga, ON",
    rating: 5,
    text:
      "Kitchen reno came in on budget and a week early. The crew was respectful, tidy and the finish is stunning. Already booking them for the upstairs bath.",
    project: "Kitchen Remodel",
  },
  {
    name: "Anita K.",
    location: "Markham, ON",
    rating: 5,
    text:
      "Called at 11pm with a burst pipe. They were at my door in under an hour. Couldn't recommend Prime GTA more for emergency work.",
    project: "Emergency Plumbing",
  },
];

export default function Testimonials() {
  return (
    <section
      id="reviews"
      className="py-24 lg:py-36 bg-[#FAF7F2] relative"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-10 h-px bg-[#B08D5B]" />
            <span className="label-overline text-[10px] text-[#B08D5B]">In Their Words</span>
            <span className="w-10 h-px bg-[#B08D5B]" />
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight font-light text-[#0B1B33] leading-[1.05]">
            Homeowners who chose us once,
            <br />
            <span className="italic text-[#B08D5B]">called us back.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-testid="testimonials-grid">
          {REVIEWS.map((r, idx) => (
            <article
              key={r.name}
              className="relative bg-white border border-[#EDE6D8] p-8 lg:p-10 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(11,27,51,0.18)] hover:border-[#B08D5B]/40 group"
              data-testid={`testimonial-${idx}`}
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#B08D5B]/15 group-hover:text-[#B08D5B]/30 transition-colors duration-500" />
              <div className="flex gap-0.5 mb-5">
                {[...Array(r.rating)].map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5 fill-[#B08D5B] text-[#B08D5B]" />
                ))}
              </div>
              <p className="font-heading text-lg text-[#0B1B33] leading-[1.6] italic font-normal">
                "{r.text}"
              </p>
              <div className="mt-8 pt-6 border-t border-[#EDE6D8] flex items-center justify-between">
                <div>
                  <div className="font-heading font-medium text-[#0B1B33]">{r.name}</div>
                  <div className="text-xs text-stone-500 font-body mt-0.5">{r.location}</div>
                </div>
                <span className="label-overline text-[9px] text-[#B08D5B]">{r.project}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
